import { openCart } from '../modules/cart';
import { loadCartAmount } from '../modules/cart';

const nonce = window.nonce;

export function init() {
  const productOrderSubmit = document.querySelector('[data-product-order-submit]');
  const stickyBar = document.querySelector('[data-sticky-product-order]');

  if (!productOrderSubmit || !stickyBar) return;

  const submit = stickyBar.querySelector('[data-sticky-product-order-submit]');

  submit.addEventListener('click', handleClick);

  setTimeout(() => {
    handleScroll();
  }, 2000);

  window.addEventListener('scroll', handleScroll);
  window.addEventListener('resize', handleScroll);

  function handleScroll() {
    const rect = productOrderSubmit.getBoundingClientRect();

    if (rect.top < -100) {
      stickyBar.classList.add('is-active');
    } else {
      stickyBar.classList.remove('is-active');
    }
  }

  function handleClick(event) {
    event.preventDefault();
    setLoader();

    const pid = submit.dataset.productId;

    if (!pid) return;

    $.ajax({
      type: 'POST',
      url: '/wp-json/wc/store/cart/add-item',
      dataType: 'json',
      headers: {
        'Nonce': nonce,
      },
      data: {
        id: pid,
        quantity: 1,
      },
      success: function () {
        openCart();
        loadCartAmount();
        resetLoader();
      },
    });
  }

  function setLoader() {
    submit.classList.add('is-loading');
    submit.disabled = true;
  }

  function resetLoader() {
    submit.classList.remove('is-loading');
    submit.disabled = false;
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/sticky-product-order.js